import React, { useState } from "react";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { checkHttpStatus } from "../../Shared/utility";

const SetupForm = ({
  closeModal,
  storeId,
  setCreditCardsList,
  currentTab,
  setAchData,
  setCurrentCardNumber,
  setCurrentAccNumber,
  achAccountList,
  creditCardsList,
  setCardBrandName,
  setAddNewCartData,
  setAddNewACHAccountData,
  setErrorMsgPlaceOrder,
  setErrorMsg,
}) => {
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState(null);
  const [saveForFutureUse, setSaveForFuture] = useState("N");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      setErrorMessage("Payment form is still loading. Please try again.");
      return null;
    }
    setIsSubmitting(true);
    setErrorMessage(null);

    try {
      const { error: submitError } = await elements.submit();
      if (submitError) {
        setErrorMessage(
          submitError.message ||
            "Unable to validate payment details. Please review and try again."
        );
        return;
      }

      const { error, setupIntent } = await stripe.confirmSetup({
        //`Elements` instance that was used to create the Payment Element
        elements,
        redirect: "if_required",
      });

      if (error) {
        // This point will only be reached if there is an immediate error when
        // confirming the payment. Show error to your customer (for example, payment
        // details incomplete)
        setErrorMessage(error.message);
        console.error("CHECKOUT_STRIPE_CONFIRM_SETUP_ERROR", {
          tab: currentTab,
          message: error.message,
        });
        return;
      }

      if (!setupIntent?.id || !setupIntent?.client_secret) {
        throw new Error("Stripe setup intent response is missing required fields");
      }

      const token = document.getElementById("reactWCToken")?.value;
      //https://localhost/wcs/resources/store/10051/stripe/fetchPaymentIntent
      const response = await fetch(
        `/wcs/resources/store/${storeId}/stripe/fetchPaymentIntent`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            WCAuthToken: token
              ? token
              : "331732%2C4cz6xGvFnASx0JELVXW0E3GFFeFtzozCzHY8u16FNEE%3D",
          },
          body: JSON.stringify({
            setup_intent: setupIntent.id,
            setup_intent_client_secret: setupIntent.client_secret,
          }),
        }
      );
      const data = await checkHttpStatus(response);
      const stripePaymentIntent = data?.stripePaymentIntent;

      if (currentTab === "card" && stripePaymentIntent) {
        const cardExpiryMonth = stripePaymentIntent.cardExpiryMonth || "";
        const cardExpiryYear = stripePaymentIntent.cardExpiryYear || "";
        const newCardDataObj = {
          cardCVV: "",
          cardExpiry: `${cardExpiryMonth}${cardExpiryYear.slice(-2)}`,
          cardBrand: stripePaymentIntent.cardType,
          stripeCustomerId: stripePaymentIntent.customerId,
          cardNumber: stripePaymentIntent.last4DigitCardNumber,
          cardSequence: "",
          X_approvedNewCreditcard: "Y",
          stripeCardExpiryMonth: cardExpiryMonth,
          stripeCardExpiryYear: cardExpiryYear.slice(-2),
          stripeCardId: stripePaymentIntent.paymentMethodId,
          saveForFuture: saveForFutureUse,
        };
        setCreditCardsList((prevState) => {
          return [...prevState, newCardDataObj];
        });
        setCardBrandName(newCardDataObj.cardBrand);
        setAddNewCartData(newCardDataObj);

        setCurrentCardNumber(creditCardsList.length);
        //setErrorMsgPlaceOrder("");
        setErrorMsg("");
        closeModal(false);
      } else if (currentTab === "ach" && stripePaymentIntent) {
        const achObj = {
          accountSequence: "",
          accountType: stripePaymentIntent.accountType,
          bankName: stripePaymentIntent.bankName,
          accountNumber: stripePaymentIntent.accountNumber,
          stripeCustomerId: stripePaymentIntent.customerId,
          paymentMethodId: stripePaymentIntent.paymentMethodId,
          X_approvedNewACHAccount: "Y",
          saveForFuture: saveForFutureUse,
          statusPaymentIntent: stripePaymentIntent.statusPaymentIntent,
        };
        setAchData((prevState) => {
          return [...prevState, achObj];
        });

        setAddNewACHAccountData(achObj);

        setCurrentAccNumber(achAccountList.length);
        //setErrorMsgPlaceOrder("");
        setErrorMsg("");
        closeModal(false);
      } else {
        throw new Error("Stripe payment intent response is missing");
      }
    } catch (error) {
      const message =
        error?.message ||
        "Unable to save payment method right now. Please try again.";
      console.error("CHECKOUT_STRIPE_SAVE_PAYMENT_ERROR", {
        tab: currentTab,
        message,
      });
      setErrorMessage(message);
      setErrorMsg(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const saveForFuture = () => {
    if (
      document.getElementById("savecardforfuture") &&
      document.getElementById("savecardforfuture").checked === true
    ) {
      setSaveForFuture("Y");
    } else {
      setSaveForFuture("N");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2>
        {currentTab === "card" ? "Add a credit or debit card" : "Add ACH"}
      </h2>
      <PaymentElement />
      {currentTab === "card" || currentTab === "ach" ? (
        <div className="saveCardForFuture">
          <input
            type="checkbox"
            id="savecardforfuture"
            name="savecardforfuture"
            value=""
            onClick={() => saveForFuture()}
          />
          <label htmlFor="savecardforfuture"> Save card for future use</label>
        </div>
      ) : null}
      <button
        className="pri-btn add-your-card-modal-btn"
        disabled={!stripe || isSubmitting}
      >
        {currentTab === "card" ? "Add your card" : "Add ACH"}
      </button>
      {errorMessage ? <div className="checkout-error-message">{errorMessage}</div> : null}
    </form>
  );
};

export default SetupForm;
